<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t('search.title')}}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span
                            style="margin-left:5px;display:inline-block;"
                          >{{$t('service_history.date_from')}}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="search.checkin_from_date"
                      v-model="search.checkin_from_date"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span
                            style="margin-left:5px;display:inline-block;"
                          >{{$t('service_history.date_to')}}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker :config="options" :value="search.checkin_to_date" v-model="search.checkin_to_date"></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchApartmentReservation"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.reservation_code')"
                  v-model="search.reservation_code"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchApartmentReservation"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.apartment_code')"
                  v-model="search.apartment_code"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchApartmentReservation"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.reservations.customer_name')"
                  v-model="search.customer_name"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchApartmentReservation"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
                <button
                  type="button"
                  class="btn btn-default pull-right"
                  @click="onExport"
                >
                  <span class="btn-label">
                    <i class="fa fa-download"></i>
                  </span>
                  {{$t('customer.export')}}
                </button>
              </div>
            </div>
          </div>

        </div>
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{$t('apartment.reservations.title')}}</b>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12 table-responsive no-padding">
                  <b-table :items="apartmentReservationList" :fields="apartmentReservationFields" class="mt-3 fixed-table" outlined>
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template slot="target" slot-scope="row">
                      <a :href="row.item.url" target="_blank" :id="`apartment_reservation_target_${row.item.id}`">{{row.item.target}}</a>
                      <tooltip :text="row.item.url" :target="`#apartment_reservation_target_${row.item.id}`"/>
                    </template>
                    <template slot="status" slot-scope="row">
                      <span :style="{ color: row.item.text_color}">{{row.item.status}}</span>
                    </template>
                    <template slot="actions" slot-scope="row">
                      <template>
                        <div class="btn-group">
                          <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                            <i class="fa fa-fw fa-ellipsis-h"></i>
                          </button>
                          <ul class="dropdown-menu hide-scroll-bar" style="min-width: 50px;max-height: 120px;">
                            <li style="margin-bottom: 5px;" v-if="row.item.status !== $t('apartment.reservations.expired') && row.item.status !== $t('apartment.reservations.checkedout') && row.item.status !== $t('apartment.reservations.cancelled') && row.item.status !== $t('apartment.reservations.confirmed') && row.item.status !== $t('apartment.reservations.booking_expired') && row.item.status !== $t('apartment.reservations.checkout')">
                              <button
                                class="btn btn-primary btn-sm"
                                style="margin-left: 6px;"
                                @click="showModalRowInvoiceBookingPayment(row.item)"
                              >
                                <i class="glyphicon glyphicon-edit"></i>
                              </button>
                            </li>
                            <li style="margin-bottom: 5px;">
                              <button
                                class="btn btn-info btn-sm"
                                style="margin-left: 6px;"
                                @click="onViewBookingDetail(row)"
                              >
                                <i class="glyphicon glyphicon-eye-open"></i>
                              </button>
                            </li>
                            <li>
                              <button
                                class="btn btn-success btn-sm"
                                style="margin-left: 6px;"
                                @click="onShowModalCopyBooking(row)"
                              >
                                <i class="glyphicon glyphicon-copyright-mark"></i>
                              </button>
                            </li>
                          </ul>
                      </div>
                      </template>
                    </template>
                    <template slot="reservation_code" slot-scope="row">
                      <template>
                          <div style="cursor: pointer;" @click="onViewBookingDetail(row)">
                            {{row.item.reservation_code}}
                          </div>
                      </template>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Booking Payment -->
        <div class="modal fade" :ref="`modal-booking-payment`">
          <div class="modal-dialog modal-lg">
            <LeaseBackBookingPayment
              ref="bookingPaymentComponent"
              :item="bookingPaymentData"
              @onAdd="onAddPayment"
              @onSave="onSavePayment"
              @onCheckout="onCheckoutApartmentBooking"
              @onClose="onClosePayment"
            />
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <!-- END Modal Booking Payment -->

        <!-- Start Modal apartment available -->
        <lte-modal-apartment-available-leaseback
          ref="apartmentAvailableLeaseback"
        />
        <!-- End -->

        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import XLSX from "xlsx";
import utils from '@/lib/utils'
import moment from 'moment'
import LeaseBackBookingPayment from "./LeaseBackBookingPayment"
import datePicker from "vue-bootstrap-datetimepicker";
import LTEModalApartmentAvailableLeaseback from '@/components/LTEModalApartmentAvailableLeaseback.vue'
import BookingStatusEnum from "@/enum/bookingStatusEnum";

export default {
  name: "ApartmentReservationList",
  data() {
    return {
      bookingPaymentData: {
        booking_id: 0,
        apartment_id: 0
      },
      apartmentReservationList: [],
      apartmentReservationFields: [
        { key: 'no', label: "common.nonumber", class: 'text-center' },
        { key: 'reservation_code', label: "apartment.reservations.reservation_code", class: 'text-center' },
        { key: 'apartment_code', label: 'apartment.reservations.apartment_code', class: 'text-center' },
        { key: 'customer_name', label: 'apartment.reservations.customer_name', class: 'text-center' },
        { key: 'company', label: 'apartment.reservations.company', class: 'text-center long-text-col-td' },
        { key: 'no_client', label: 'apartment.reservations.no_client', class: 'text-center' },
        { key: 'date_checkin', label: 'apartment.reservations.date_checkin', class: 'text-center'},
        { key: 'date_checkout', label: 'apartment.reservations.date_checkout', class: 'text-center'},
        { key: 'other_details', label: 'apartment.reservations.other_details', class: 'text-center long-text-col-td' },
        { key: 'status', label: 'apartment.reservations.status', class: 'text-center' },
        { key: "actions", label: "common.action", class: 'text-center' }
      ],
      isLoading: false,
      otherBookingDetails: "",
      apartmentReservationItem: {},
      apartmentReservationData: [],
      search: {
        apartment_code: "",
        reservation_code: "",
        customer_name: "",
        checkin_from_date: "",
        checkin_to_date: ""
      },
      options: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
      },
      disabledCheckin: true,
      checkin_datetime: null,
      checkout_datetime: null,
    };
  },
  watch: {
    GET_LANG: function() {
      this.GET_APARTMENT_RESERVATION_LIST().then(
        function(res) {
          // Todo on watch
        }
      ).catch(
        function(error) {
          this.isLoading = false
        }
      )
    },
    GET_APARTMENT_RESERVATION_LIST_DATA: function() {
      this.isLoading = false
      this.apartmentReservationData = this.GET_APARTMENT_RESERVATION_LIST_DATA.data
      this.apartmentReservationList = []
      for (let i = 0, size = this.apartmentReservationData.length; i < size; i++) {
        this.checkin_datetime = utils.formatSqlDate(this.apartmentReservationData[i].checkin_datetime, null, this.options.format)
        this.checkout_datetime = utils.formatSqlDate(this.apartmentReservationData[i].checkout_datetime, null, this.options.format)
        let company = this.apartmentReservationData[i].booking_company ? this.apartmentReservationData[i].booking_company_details.company : "Khách Lẻ"
        let status = this.getStatus(this.apartmentReservationData[i])
        let object = {
          'no': i + 1,
          'id': this.apartmentReservationData[i].id,
          'reservation_code': this.apartmentReservationData[i].booking_code,
          'apartment_code': this.apartmentReservationData[i].apartment && this.apartmentReservationData[i].apartment.apartment_code,
          'customer_name': this.apartmentReservationData[i].booking_person_name,
          'date_checkin': this.checkin_datetime,
          'date_checkout': this.checkout_datetime,
          'company': company,
          'no_client': this.apartmentReservationData[i].apartment_lease_back_clients_ids.length,
          'status': status.text_status,
          'other_details': this.apartmentReservationData[i].other_booking_details,
          'apartment': this.apartmentReservationData[i].apartment.id,
          'text_color': status.text_color,
          'number_of_room': this.apartmentReservationData[i].apartment.bedroom_count,
          'is_view_only': status.text_status == this.$t('apartment.reservations.checkout') || status.text_status == this.$t('apartment.reservations.expired') || status.text_status == this.$t('apartment.reservations.checkout_expired') ? true : false
        }
        this.apartmentReservationList.push(object)
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_APARTMENT_RESERVATION_LIST_DATA",
      "GET_SNACK_BAR",
      "GET_LANG"
    ])
  },
  methods: {
    ...mapActions([
      "GET_APARTMENT_RESERVATION_LIST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      // "UPDATE_APARTMENT_RESERVATION",
    ]),
    ...mapActions("bookingModule", [
      "ADD_BOOKING_PAYMENT",
      "SAVE_BOOKING_PAYMENT"
    ]),
    onShowModalCopyBooking: function(row) {
      this.$refs.apartmentAvailableLeaseback.showModalApartmentAvailableLeaseback(row.item.id, row.item.number_of_room, row.item.date_checkin, row.item.date_checkout);
    },
    //START: actions related to payment modal
    onToggleBookingPaymentModal: function(action="show") {
      $(this.$refs[`modal-booking-payment`]).modal(action)
    },
    showModalRowInvoiceBookingPayment: function(item) {
      const data = {
        booking_id: item.id,
        apartment_id: item.apartment
      }
      this.bookingPaymentData = data
      this.onToggleBookingPaymentModal()
    },
    onAddPayment: function(saveBookingPayment, checkout_evt) {
      this.ADD_BOOKING_PAYMENT(saveBookingPayment).then(
        function(res) {
          if (checkout_evt) {
            this.$refs.bookingPaymentComponent.checkOut();
          }
          this.onToggleBookingPaymentModal("hide");
        }.bind(this)
      );
    },
    onSavePayment: function(id, saveBookingPayment){
      this.SAVE_BOOKING_PAYMENT({id: id, data: saveBookingPayment}).then(
        function(res){
          this.onToggleBookingPaymentModal("hide")
          this.getPaymentList()
        }.bind(this)
      )
    },
    onCheckoutApartmentBooking: function(action = "hide") {
      $(this.$refs[`modal-booking-payment`]).modal(action);
      this.isLoading = true
      this.onSearchApartmentReservation()
    },
    onClosePayment: function(){
      this.onToggleBookingPaymentModal("hide");
    },
    //END: actions related to payment modal
    onViewBookingDetail: function(row) {
      this.$router.push({
        name: "LeaseBackApartmentBooking",
        params: {
          id: row.item.id
        },
        query: {
          checkin_datetime: row.item.checkin_datetime,
          checkout_datetime: row.item.checkout_datetime,
          is_view_only: row.item.is_view_only
        }
      });
    },
    onExport: function() {
      let exported_data = []
      this.apartmentReservationList.forEach(v => {
        let item = {
          'Mã Đặt Chỗ': v.reservation_code,
          'Mã Căn Hộ': v.apartment_code,
          'Tên Khách Hàng': v.customer_name,
          'Đơn Vị': v.company,
          'Số Khách Hàng': v.no_client,
          'Ngày Nhận Phòng': v.date_checkin,
          'Ngày Trả Phòng': v.date_checkout,
          'Chi Tiết Khác': v.other_details,
          'Tình Trạng': v.status,
        }
        exported_data.push(item)
      })
      var data = XLSX.utils.json_to_sheet(exported_data);
      var wscols = [
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20}
      ];
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "booking");
      data['!cols'] = wscols;
      // export Excel file
      XLSX.writeFile(wb, `BookingList` + '_' + `${this.search.checkin_from_date}` + '_' + `${this.search.checkin_to_date}.xlsx`); // name of the file is 'book.xlsx'
    },
    updateDateCheckinCheckout: function() {
      this.disabledCheckin = false
    },
    searchApartmentReservation: function() {
      // this.$router.push({
      //   name: "ApartmentReservationList",
      //   query: {
      //     checkin_from_date: this.search.checkin_from_date,
      //     checkin_to_date: this.search.checkin_to_date
      //   }
      // });
      // this.$router.push({ query: Object.assign(this.$route.query, {
      //   checkin_from_date: this.search.checkin_from_date,
      //   checkin_to_date: this.search.checkin_to_date
      // }) })
      // [place hoder]
    },
    onSearchApartmentReservation: function() {
      let checkin_from_date = utils.formatSqlDate(this.search.checkin_from_date, this.options.format, "DD/MM/YYYY");
      let checkin_to_date = utils.formatSqlDate(this.search.checkin_to_date, this.options.format, "DD/MM/YYYY");
      const data = {
        params: {
          page: 1,
          reservation_code: this.search.reservation_code,
          apartment_code: this.search.apartment_code,
          customer_name: this.search.customer_name,
          checkin_from_date: checkin_from_date,
          checkin_to_date: checkin_to_date
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_RESERVATION_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      ).catch(
        function(){
          this.isLoading = false;
        }.bind(this)
      );
    },
    isTodayOrFuture: function(date_data){
      let current_date = moment().format('YYYY-MM-DD')
      date_data = moment(date_data).format('YYYY-MM-DD') == 'Invalid date' ? moment(date_data, 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD') : moment(date_data).format('YYYY-MM-DD')
      // let today_m = {
      //   day: moment().date(),
      //   month: moment().month() + 1,
      //   year: moment().year()
      // }
      // let date_data_m = {
      //   day: moment(date_data).date(),
      //   month: moment(date_data).month() + 1,
      //   year: moment(date_data).year(),
      // }
      // today_m = moment([today_m.year, today_m.month, today_m.day])
      // date_data_m = moment([date_data_m.year, date_data_m.month, date_data_m.day])
      if (date_data > current_date) { // today or future
        return true
      }
      return false
    },
    getStatus: function (data) {
      if (!utils.isNull(data.booking_status)) {
        if (!this.isTodayOrFuture(data.deposit_deadline) && (data.deposit_request == 0 || utils.isNull(data.deposit_request)) && (data.payment_inadvance_request == 0 || utils.isNull(data.payment_inadvance_request))) {
          return {
            text_status: this.$t('apartment.reservations.deposit_expired'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.WAITING) {
          return {
            text_status: this.$t('apartment.reservations.waiting'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.CONFIRMED) {
          if (!this.isTodayOrFuture(data.checkin_datetime) && this.isTodayOrFuture(data.checkout_datetime)){
            return {
              text_status: this.$t('apartment.reservations.booking_expired'),
              text_color: 'red'
            }
          } else if (!this.isTodayOrFuture(data.checkin_datetime) && !this.isTodayOrFuture(data.checkout_datetime)) {
             return {
              text_status: this.$t('apartment.reservations.expired'),
              text_color: 'orange'
            }
          }
          return {
            text_status: this.$t('apartment.reservations.confirmed'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.RESERVED) {
          return {
            text_status: this.$t('apartment.reservations.reserved'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.DEPOSIT) {
          return {
            text_status: this.$t('apartment.reservations.deposit'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.PAID) {
          return {
            text_status: this.$t('apartment.reservations.paid'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.CANCELLED) {
          return {
            text_status: this.$t('apartment.reservations.cancelled'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.PENDING) {
          return {
            text_status: this.$t('apartment.reservations.pending'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.ONBOARD) {
          if (!this.isTodayOrFuture(data.checkout_datetime)){
            return {
              text_status: this.$t('apartment.reservations.checkout_expired'),
              text_color: null
            }
          }
          return {
            text_status: this.$t('apartment.reservations.onboard'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.EXPIRED) {
          return {
            text_status: this.$t('apartment.reservations.expired'),
            text_color: 'orange'
          }
        } else if (data.booking_status == BookingStatusEnum.CHECKOUT) {
          return {
            text_status: this.$t('apartment.reservations.checkout'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.CHECKINCOMMINGSOON) {
          return {
            text_status: this.$t('apartment.reservations.checkin_comming_soon'),
            text_color: null
          }
        } else if (data.booking_status == BookingStatusEnum.CHECKOUTCOMMINGSOON) {
          return {
            text_status: this.$t('apartment.reservations.checkout_comming_soon'),
            text_color: null
          }
        }
      } else {
        return ''
      }
    },
    showModalCheckIn: function(item) {
      this.$refs.modalBookingDetail.submit(item.item.id)
    },
    onOpenBokingDetails: function(row) {
      let booking_id = row.item.id
      this.$router.push({
        name: "LeaseBackBookingInfoView",
        params: {
          id: booking_id
        }
      })
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    LeaseBackBookingPayment,
    "date-picker": datePicker,
    "lte-modal-apartment-available-leaseback": LTEModalApartmentAvailableLeaseback
  },
  mounted() {
    // search info
    let checkin_to_date = new Date();
    checkin_to_date.setDate(checkin_to_date.getDate() + 7);
    this.search.checkin_from_date = this.$route.query.checkin_from_date != null
        ? this.$route.query.checkin_from_date : moment(new Date(), this.options.format).format("DD/MM/YYYY");
    this.search.checkin_to_date = this.$route.query.checkin_to_date != null
        ? this.$route.query.checkin_to_date : moment(checkin_to_date, this.options.format).format("DD/MM/YYYY");
    let dateViewOptions = sessionStorage.getItem('projectDateViewOptions')
    if (!utils.isNull(dateViewOptions)) {
      this.options.format = dateViewOptions
      this.isLoading = true
      this.onSearchApartmentReservation()
    }
  }
};
</script>

<style scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar { 
  display: none; 
} 

.fixed-table {
  table-layout: fixed;
}

.long-text-col-td {
  text-overflow: ellipsis;
  overflow: hidden;
  /* white-space: nowrap; */
}

</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentReservationList.vue